<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="finalRules"
      class="login-form"
      auto-complete="on"
      label-position="left"
      @submit.native.prevent="handleLogin"
    >
      <h3 class="title">{{ systemName }}</h3>
      <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
        <el-input
          v-model.trim="loginForm.username"
          name="username"
          type="text"
          auto-complete="on"
          placeholder="请输入用户名"
        />
      </el-form-item>
      <el-form-item prop="password" v-if="loginWithPassword">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input
          :type="pwdType"
          v-model.trim="loginForm.password"
          name="password"
          auto-complete="on"
          placeholder="请输入密码"
          @keyup.enter.native="handleLogin"
          @keypress.native="keydown($event)"
        />
        <span class="show-pwd" @click="showPwd">
          <svg-icon v-if="pwdType" icon-class="eye" />
          <i v-else class="el-icon-view" />
        </span>
      </el-form-item>
      <el-form-item prop="captcha">
        <span class="svg-container">
          <svg-icon icon-class="message" />
        </span>
        <el-input
          ref="captchaInput"
          v-model.trim="loginForm.captcha"
          name="msgCode"
          placeholder="请输入短信验证码"
          style="width: 50%"
        />
        <el-button
          :disabled="countNumber > 0"
          type="text"
          style="line-height: 45px;float:right;padding:0;padding-right:16px"
          @click="handleSendMsg"
          >{{
            countNumber > 0 ? `重新获取(${countNumber})` : '获取短信验证码'
          }}</el-button
        >
      </el-form-item>
      <el-form-item style="border:none;">
        <el-button
          :loading="loading"
          type="primary"
          native-type="submit"
          style="width:100%;height:45px;"
          @click.native.prevent="handleLogin"
        >
          登录
        </el-button>
      </el-form-item>
    </el-form>
    <!-- 微信小程序码 -->
    <wx-code-popover :loginIn="false" placement="left" />
  </div>
</template>

<script>
import svgIcon from '../svg-icon'

export default {
  name: 'QSLogin',
  components: { svgIcon },
  props: {
    systemName: {
      type: String,
      default: 'APP定制平台',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    countNumber: {
      type: Number,
      default: 0,
    },
    loginWithPassword: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length < 5) {
        callback(new Error('密码不能小于5位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: '',
        captcha: '',
      },
      extraRules: {
        captcha: [{ required: true, trigger: 'blur', message: '验证码必填' }],
      },
      usernameRules: {
        username: [{ required: true, trigger: 'blur', message: '用户名必填' }],
      },
      passwordRules: {
        password: [{ required: true, trigger: 'blur', validator: validatePass }],
      },
      finalRules: {},
      pwdType: 'password',
    }
  },
  methods: {
    // 发送验证码
    handleSendMsg() {
      if (this.loginWithPassword) {
        this.finalRules = {
          username: this.usernameRules.username,
          password: this.passwordRules.password,
        }
      } else {
        this.finalRules = {
          username: this.usernameRules.username,
        }
      }
      this.$nextTick(() => {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.$emit('handleSendMsg', this.loginForm)
            this.$refs.captchaInput.focus()
          }
        })
      })
    },
    // 登录
    handleLogin() {
      this.finalRules = { captcha: this.extraRules?.captcha }
      if (this.loginWithPassword) {
        this.finalRules = {
          ...this.finalRules,
          username: this.usernameRules.username,
          password: this.passwordRules.password,
        }
      } else {
        this.finalRules = {
          ...this.finalRules,
          username: this.usernameRules.username,
        }
      }
      this.$nextTick(() => {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.$emit('handleLogin', this.loginForm)
          }
        })
      })
    },
    // 显示密码
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    keydown(e) {
      if (e.keyCode === 32) {
        e.returnValue = false
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    skipToForgetPassword() {
      this.$emit('skipToForgetPassword')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss">
$light_gray: #232323;

/* reset element-ui css */
.login-container {
  position: relative;
  .el-input {
    display: flex;
    height: 45px;
    flex: 1;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 45px;
      box-shadow: none;
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
        -webkit-text-fill-color: #232323 !important;
      }
    }
  }
  .el-form-item {
    color: #c8c9cc;
    border: 1px solid #dcdee0;
    border-radius: 2px;
    line-height: 45px;
    .el-form-item__content {
      display: flex;
    }
    &.el-form-item--small {
      margin-bottom: 24px;
    }
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
$dark_gray: #889aa4;
$light_gray: #232323;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background: #212f40 url('~@/assets/img/bg_login_chewu.png') no-repeat;
  background-size: cover;
  .login-form {
    position: absolute;
    left: auto;
    top: 50%;
    transform: translateY(-50%);
    right: 148px;
    width: 454px;
    max-width: 100%;
    padding: 37px;
    /* margin: 120px auto; */
    border-radius: 16px;
    background-color: #fff;
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 45px;
    display: inline-block;
    background-color: #f7f8fa;
    line-height: 34px;
    border-right: 1px solid #dcdee0;
  }
  .title {
    font-size: 24px;
    color: #232323;
    font-weight: 400;
    margin: 0px auto 37px auto;
    text-align: center;
    font-weight: bold;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .text-right {
    text-align: right;
  }
}

@media screen and (max-width: 602px) {
  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: static;
    overflow-x: auto;
    .login-form {
      width: 320px;
      flex-shrink: 0;
      position: static;
      transform: none;
      max-width: none;
    }
  }
}
</style>
